<template>
  <div class="h-100">
    <v-row class="h-100">
      <v-col class="h-50" cols="6">
        <v-row class="h-25">User ID :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ useridCount }}</v-col>
        </v-row>
        <v-row class="h-25">Sessions :</v-row>
        <v-row class="h-75" @contextmenu="onContextmenuChart">
          <v-col class="text-right mr-3 text-h4">{{ sessionCount }}</v-col>
        </v-row>
      </v-col>
      <v-col class="h-100" cols="6">
        <v-row class="h-25">Type :</v-row>
        <v-row class="h-75">
          <v-col class="text-right mr-3">
            <!--BEGIN::Modified.by.KWShin.2024.01.14.-->
            <!--chart-type :values="type.values" :colors="type.colors" area-style="linearGradient" :contextmenu="onContextmenuChart" /-->
            <chart-type ref="userType" :values="type.values" :colors="type.colors" :animation="true" area-style="linearGradient" :contextmenu="onContextmenuChartNative" />
            <!--FINISH::Modified.by.KWShin.2024.01.14.-->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </v-row>
  </div>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import ChartType from '../chart/Pie.vue';
// import { api } from '@/api/common/instances';
import { isEmpty } from 'lodash';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    ChartType,
  },
  props: {
    // BEGIN::Added.by.KWShin.2024.02.14.
    typeColors: {
      type: String,
      required: true,
    },
    // FINISH::Added.by.KWShin.2024.02.14.
  },
  data() {
    return {
      useridCount: 0,
      sessionCount: 0,
      type: {
        values: [],
        // BEGIN::Modified.by.KWShin.2024.01.11
        // colors: [DEFAULT_COLORS[3], DEFAULT_COLORS[9], DEFAULT_COLORS[2], DEFAULT_COLORS[0], DEFAULT_COLORS[1], DEFAULT_COLORS[4], DEFAULT_COLORS[5]],
        colors: [],
        colorsDefault: ['#9E9E9E', '#7986CB', '#039BE5', '#26A69A'],
        // FINISH::Modified.by.KWShin.2024.01.11
      },
      contextmenuUrl: '/views/detailview/abap/user',
    };
  },
  // BEGIN::Added.by.KWShin.2024.01.11
  // Pie 차트의 색상이 하드코딩 되어 있던 걸,
  // CONF_USER_MTL에서 설정을 읽어와서 적용하도록 기능 추가.
  // Whole.vue에서 한번 읽어와서 인스턴스들에 props로 전파해준다.
  watch: {
    typeColors: {
      immediate: true,
      handler(value) {
        if (!isEmpty(value)) this.type.colors = value.split(',');
        else this.type.colors = this.type.colorsDefault;
      },
    },
  },
  // FINISH::Added.by.KWShin.2024.01.11
  methods: {
    //BEGIN::modified.by.KWShin.2024.03.22.
    /*
    wsBufferedDataHandler(key, responses, every) {
      this.type.values = ['System', 'GUI', 'RFC', 'Plugin'].map(type => ({ value: 0, name: type }));
      responses.forEach(response => every(key, response.length ? response[response.length - 1].data : []));
    },
    wsDataHandler(key, response) {
      this.useridCount = 0;
      this.sessionCount = 0;
      this.type.values.forEach(row => (row.value = 0));
      response.forEach(res => {
        this.useridCount += !!res.type && res.type != 'RFC' ? 1 : 0;
        this.sessionCount += parseInt(res.extmodi);
        if (!this.type.values.filter(row => row.name == res.type).length) this.type.values.push({ value: 0, name: res.type });
        ////////////////////////////////////////////////////////////////////////////////////////////
        // 사용자 유형별로 Session수를 보여줄 때, 그냥 ++ 하면 안되고, extmodi 수를 더해주어야 한다.
        // 2021.07.22.KWShin.
        ////////////////////////////////////////////////////////////////////////////////////////////
        // this.type.values.filter(row => row.name == res.type)[0].value++;
        ////////////////////////////////////////////////////////////////////////////////////////////
        this.type.values.filter(row => row.name == res.type)[0].value += parseInt(res.extmodi);
        ////////////////////////////////////////////////////////////////////////////////////////////
      });
    },
    */
    wsDataHandler(key, response) {
      this.useridCount = 0;
      this.sessionCount = 0;
      this.type.values.forEach(row => (row.value = 0));
      response.forEach(rspn => {
        this.useridCount += parseInt(rspn.idCnt);
        this.sessionCount += parseInt(rspn.sssnCnt);
        if (this.type.values.filter(row => row.type == rspn.logonType).length == 0) this.type.values.push({ value: 0, type: rspn.logonType });
        this.type.values.filter(row => row.type == rspn.logonType)[0].value += parseInt(rspn.sssnCnt);
      });
      this.type.values.forEach(v => {
        v.name = this.$t(`logon.user.type.${v.type}`);
        switch (v.type) {
          case '2':
            v.colorIndex = 0;
            break;
          case '4':
            v.colorIndex = 1;
            break;
          case '32':
            v.colorIndex = 2;
            break;
          case '202':
            v.colorIndex = 3;
            break;
          default:
            v.colorIndex = 0;
        }
      });
    },
    //FINISH::modified.by.KWShin.2024.03.22.
  },
  created() {
    //BEGIN::modified.by.KWShin.2024.03.22.
    /*
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'rawLogonUser', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: ['extmodi', 'type'],
          empty: false,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        },
      ],
    });
    */
    this.$websocket.realtime.send({
      requests: [
        {
          key: { name: 'cntLogonUserType', sstmId: this.instance.systemId, instId: this.instance.id },
          fields: ['logonType', 'idCnt', 'sssnCnt'],
          empty: false,
          handler: {
            every: this.wsDataHandler,
          },
        },
      ],
    });
    //FINISH::modified.by.KWShin.2024.03.22.
  },
};
</script>
